exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-progress-spinner path, .mat-spinner path{stroke: #b50721 !important;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/adminpack-upgrade/adminpack-upgrade.component.css
// module id = ../../../../../src/app/adminpack-upgrade/adminpack-upgrade.component.css
// module chunks = 39